import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { LoadingService } from '@processo/services/loading.service';
import { NotificationService } from '@processo/services/notification.service';
import { AuthService } from '../authentication/auth.service';
import { TokenService } from '@processo/services/token.service';
import { Router } from '@angular/router';
import { logAuthEvent, describeHttpError } from '@processo/core/helpers/auth-diag.util';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private _nt = inject(NotificationService);
  private _loading = inject(LoadingService);
  private _token = inject(TokenService);
  private _router = inject(Router);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (
          request.headers.get('x-suppress-error-toast') === '1' ||
          error.url.includes('add_org_role') ||
          error.url.includes('get_bncfy_credit_balance')
        ) {
        } else {

          
          this._nt.show(
            'Error',
            error.status,
            error.error?.err || error.error?.error || error.error?.org?.err || error.error?.msg || 'Something went wrong',
          );
          this._loading.hide();
        }

        if (error?.error?.error === 'Token is expired') {
          logAuthEvent('api-token-expired-logout', {
            url: (error?.url || request.url || '').split('?')[0].slice(-80),
            ...describeHttpError(error),
          });
          this._token.clearTokens();
          this._router.navigate(['/']);
        } else if (error?.status === 401) {
          // Not torn down today, but a 401 mid-session is exactly the kind of
          // event we need on the timeline.
          logAuthEvent('api-401', {
            url: (error?.url || request.url || '').split('?')[0].slice(-80),
            ...describeHttpError(error),
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
